import { useHistory } from 'react-router-dom'
import React, { useEffect, useState } from 'react';
import { Select, MenuItem, InputLabel, FormControl } from '@mui/material';
import {
    Slider,
    TextField
} from '@mui/material'
import { Header } from '../../components/Header';
import apiClient from '../../apiClient';
import { HandleAuthError, GenericStackTraceValidator } from '../universal/Alert';
import { SelectGenericFromTable } from '../universal/Axios';
import Button from '@mui/material/Button';
import { getStore } from '../../Store'
import { observer } from "mobx-react"

const store = getStore();

const GenerateInputAudios = observer(() => {
    const { push } = useHistory();

    useEffect(() => {
        SelectGenericFromTable("select * from audio_file where type = 'music' or type = 'user_uploaded_file'", store.updateMusicFiles)
    }, []);
    var initialName = new Date().toLocaleString().replace(",","");
    const [musicFileID, setMusicFileID] = React.useState('');
    const [combinedName, setCombinedName] = React.useState(initialName);
    const musicAudios = store.musicFiles.slice().sort((a, b) => a.name > b.name ? 1 : -1)
    const [stackLevel, setStackLevel] = useState(1);
    const [noiseToInstrumentVolumeRatio, setNoiseToInstrumentVolumeRatio] = useState(.5);

    const generateCombinedAudioFile = () => {
        store.updateStatusMessage("Generating combined audio file...")
        apiClient.post(
            "https://us-central1-airy-semiotics-297902.cloudfunctions.net/interactive-density-network",
            {
                "function_to_execute": "Generate_Combined_Audio",
                "instrument_audio_file_id": musicFileID,
                "stack_level": stackLevel,
                "name": combinedName,
                "noise_to_instrument_volume_ratio": noiseToInstrumentVolumeRatio,
            }
        ).then(({ data }) => {
            //dispatch(addNewNetworkRun(data))
            push('/select-input-audio')
            store.updateSuccessMessage("Successfully generated combined audio file!")
        }).catch(function (error) {
            if (error?.response?.status === 401) {
                HandleAuthError()
            } else {
                console.log(error?.response.data)
                const stackTraceMessage = GenericStackTraceValidator(error.response?.data, "CombinedAudioFile")
                if (stackTraceMessage != null) {
                    store.updateErrorMessage(stackTraceMessage)
                } else {
                    store.updateErrorMessage("Error while generating noise audio file")
                }
            }
        })
    }

    const stackLevelMarks = [{ value: 1, label: '1', }, { value: 2, label: '2', }, { value: 3, label: '3', }, { value: 4, label: '4', }, { value: 5, label: '5', }, { value: 6, label: '6', }, { value: 7, label: '7', }, { value: 8, label: '8', }, { value: 9, label: '9', }];
    const noiseToInstrumentRatioMarks = [{ value: .1, label: '.1', }, { value: .2, label: '.2', }, { value: .3, label: '.3', }, { value: .4, label: '.4', }, { value: .5, label: '.5', }, { value: .6, label: '.6', }, { value: .7, label: '.7', }, { value: .8, label: '.8', }, { value: .9, label: '.9', }, { value: 1, label: '1', }, { value: 1.1, label: '1.1', }, { value: 1.2, label: '1.2', }, { value: 1.3, label: '1.3', }, { value: 1.4, label: '1.4', }, { value: 1.5, label: '1.5', }, { value: 1.6, label: '1.6', }, { value: 1.7, label: '1.7', }, { value: 1.8, label: '1.8', }, { value: 1.9, label: '1.9', }, { value: 2, label: '2', }];
    return (
        <div>
            <Header
                pageTitle="Generate Audio"
            />
            Noise Sample Overlap Stack Level
            <Slider
                value={stackLevel}
                onChange={(event, newValue) => setStackLevel(newValue)}
                defaultValue={30}
                valueLabelDisplay="auto"
                valueLabelFormat={value => <div>{value}</div>}
                step={1}
                marks={stackLevelMarks}
                min={1}
                max={9}
            />
            Noise To Instrument Volume Ratio
            <Slider
                value={noiseToInstrumentVolumeRatio}
                onChange={(event, newValue) => setNoiseToInstrumentVolumeRatio(newValue)}
                defaultValue={.5}
                valueLabelDisplay="auto"
                valueLabelFormat={value => <div>{value}</div>}
                step={.1}
                marks={noiseToInstrumentRatioMarks}
                min={.1}
                max={2}
            />

            <FormControl style={{ width: '216px', marginRight: '10px' }}>
            <TextField
                id="name"
                label="Run Name"
                onChange={(event) => setCombinedName(event.target.value)}
                required
                defaultValue={combinedName}
                InputLabelProps={{
                    shrink: true,
                }}
                />
            </FormControl>
            <FormControl style={{ width: '216px' }}>
                <InputLabel id="music_goal">Music File</InputLabel>
                <Select
                    id="music_goal"
                    label="Music File"
                    labelId="music_goal_label"
                    value={musicFileID}
                    variant="outlined"
                    onChange={(event) => setMusicFileID(event.target.value)}
                >   {musicAudios && musicAudios?.map(x => <MenuItem value={x.id} style={{ display: "block" }}>{x.name}</MenuItem>)}
                </Select>
            </FormControl>

            <Button
                onClick={generateCombinedAudioFile}
                variant="outlined"
                sx={{ my: 2, display: 'block' }}
            >
                Generate Combined Audio File
            </Button>

        </div>
    )
})

export default GenerateInputAudios;